export default __webpack_public_path__ + "static/sprite-6ad6d97f187ac0da227ff6d2d42aac2d.svg";